import React, { useRef, useState } from 'react';
import { ButtonContainer, CharCount, Description, FeedbackModalContainer, IconContainer, Button, TextArea, Title, SuccessIcon, SuccessIconContainer } from './ScFeedbackModal';

const FeedbackModal = () => {
  const textareaRef = useRef(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [textValue, setTextValue] = useState('');
  const [selectedIcon, setSelectedIcon] = useState(null);
  const MAX_LENGTH = 2000;

  if (showSuccess) {
    return (
      <SuccessIconContainer>
        <SuccessIcon />
        <p>We have received your feedback.</p>
        <p>Thank you for helping us improve our product.</p>
      </SuccessIconContainer>
    );
  }

  const handleClick = () => {
    if (textareaRef.current) {
      console.log('Textarea değeri:', textareaRef.current.value);
    }
    setShowSuccess(true);
  };

  const handleTextChange = (event) => {
    if (event.target.value.length <= MAX_LENGTH) {
      setTextValue(event.target.value);
    }
  };


  return (
    <FeedbackModalContainer>
      <Title>Help us improve our product for you</Title>
      <Description>
        We would love to hear your thoughts on our product. What do you like and what can we improve?
      </Description>
      <IconContainer>
        <svg className={selectedIcon === 'cry' ? 'active' : ''} onClick={() => {
          setSelectedIcon('cry');
        }} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 18C36 27.941 27.941 36 18 36C8.06 36 0 27.941 0 18C0 8.06 8.06 0 18 0C27.941 0 36 8.06 36 18Z" fill="#FFCC4D" />
          <path d="M11.5 20C12.8807 20 14 18.433 14 16.5C14 14.567 12.8807 13 11.5 13C10.1193 13 9 14.567 9 16.5C9 18.433 10.1193 20 11.5 20Z" fill="#664500" />
          <path d="M24.5 20C25.8807 20 27 18.433 27 16.5C27 14.567 25.8807 13 24.5 13C23.1193 13 22 14.567 22 16.5C22 18.433 23.1193 20 24.5 20Z" fill="#664500" />
          <path d="M23.485 27.879C23.474 27.835 22.34 23.5 18 23.5C13.66 23.5 12.526 27.835 12.515 27.879C12.462 28.092 12.559 28.31 12.747 28.423C12.935 28.535 13.18 28.509 13.343 28.363C13.352 28.356 14.356 27.5 18 27.5C21.59 27.5 22.617 28.33 22.656 28.363C22.751 28.454 22.875 28.5 23 28.5C23.084 28.5 23.169 28.479 23.246 28.436C23.442 28.325 23.54 28.097 23.485 27.879Z" fill="#664500" />
          <path d="M10 30C10 32.762 7.762 35 5 35C2.238 35 0 32.762 0 30C0 27.238 4 20 5 20C6 20 10 27.238 10 30Z" fill="#5DADEC" />
          <path d="M30 13C24.446 13 22.198 8.63302 22.105 8.44702C21.858 7.95302 22.058 7.35202 22.552 7.10502C23.044 6.85802 23.644 7.05702 23.892 7.54802C23.967 7.69402 25.713 11 30 11C30.553 11 31 11.448 31 12C31 12.553 30.553 13 30 13ZM6 13C5.448 13 5 12.552 5 12C5 11.448 5.448 11 6 11C11.083 11 11.996 7.88002 12.033 7.74702C12.178 7.21902 12.723 6.89902 13.252 7.03802C13.782 7.17702 14.103 7.71102 13.97 8.24302C13.921 8.43702 12.704 13 6 13Z" fill="#664500" />
        </svg>

        <svg className={selectedIcon === 'sad' ? 'active' : ''} onClick={
          () => {
            setSelectedIcon('sad');
          }
        } width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36.75 18C36.75 27.941 28.691 36 18.75 36C8.81 36 0.75 27.941 0.75 18C0.75 8.06 8.81 0 18.75 0C28.691 0 36.75 8.06 36.75 18Z" fill="#FFCC4D" />
          <path d="M12.25 18C13.6307 18 14.75 16.433 14.75 14.5C14.75 12.567 13.6307 11 12.25 11C10.8693 11 9.75 12.567 9.75 14.5C9.75 16.433 10.8693 18 12.25 18Z" fill="#664500" />
          <path d="M25.25 18C26.6307 18 27.75 16.433 27.75 14.5C27.75 12.567 26.6307 11 25.25 11C23.8693 11 22.75 12.567 22.75 14.5C22.75 16.433 23.8693 18 25.25 18Z" fill="#664500" />
          <path d="M9.415 27.871C9.593 28.032 9.859 28.042 10.05 27.9C10.089 27.871 13.972 25 18.75 25C23.516 25 27.412 27.871 27.45 27.9C27.641 28.042 27.907 28.03 28.085 27.871C28.262 27.711 28.302 27.447 28.179 27.243C28.05 27.029 24.962 22 18.75 22C12.538 22 9.449 27.028 9.321 27.243C9.198 27.448 9.237 27.711 9.415 27.871Z" fill="#664500" />
        </svg>
        <svg className={selectedIcon === 'neutral' ? 'active' : ''} onClick={
          () => {
            setSelectedIcon('neutral');
          }
        } width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36.5 18C36.5 27.941 28.441 36 18.5 36C8.56 36 0.5 27.941 0.5 18C0.5 8.06 8.56 0 18.5 0C28.441 0 36.5 8.06 36.5 18Z" fill="#FFCC4D" />
          <path d="M12 20C13.3807 20 14.5 18.433 14.5 16.5C14.5 14.567 13.3807 13 12 13C10.6193 13 9.5 14.567 9.5 16.5C9.5 18.433 10.6193 20 12 20Z" fill="#664500" />
          <path d="M25 20C26.3807 20 27.5 18.433 27.5 16.5C27.5 14.567 26.3807 13 25 13C23.6193 13 22.5 14.567 22.5 16.5C22.5 18.433 23.6193 20 25 20Z" fill="#664500" />
          <path d="M25.5 26H11.5C10.948 26 10.5 25.553 10.5 25C10.5 24.447 10.948 24 11.5 24H25.5C26.053 24 26.5 24.447 26.5 25C26.5 25.553 26.053 26 25.5 26Z" fill="#664500" />
        </svg>
        <svg className={selectedIcon === 'happy' ? 'active' : ''} onClick={
          () => {
            setSelectedIcon('happy');
          }
        } width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.25 36C28.1911 36 36.25 27.9411 36.25 18C36.25 8.05887 28.1911 0 18.25 0C8.30887 0 0.25 8.05887 0.25 18C0.25 27.9411 8.30887 36 18.25 36Z" fill="#FFCC4D" />
          <path d="M10.765 23.621C10.81 23.8 11.933 28 18.25 28C24.568 28 25.69 23.8 25.735 23.621C25.79 23.404 25.692 23.179 25.498 23.067C25.303 22.956 25.059 22.989 24.898 23.144C24.879 23.163 22.944 25 18.25 25C13.556 25 11.62 23.163 11.602 23.145C11.506 23.05 11.378 23 11.25 23C11.166 23 11.081 23.021 11.004 23.064C10.808 23.176 10.71 23.403 10.765 23.621Z" fill="#664500" />
          <path d="M12.25 17C13.6307 17 14.75 15.433 14.75 13.5C14.75 11.567 13.6307 10 12.25 10C10.8693 10 9.75 11.567 9.75 13.5C9.75 15.433 10.8693 17 12.25 17Z" fill="#664500" />
          <path d="M24.25 17C25.6307 17 26.75 15.433 26.75 13.5C26.75 11.567 25.6307 10 24.25 10C22.8693 10 21.75 11.567 21.75 13.5C21.75 15.433 22.8693 17 24.25 17Z" fill="#664500" />
        </svg>
        <svg className={selectedIcon === 'very-happy' ? 'active' : ''} onClick={
          () => {
            setSelectedIcon('very-happy');
          }
        } width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 18C36 27.941 27.941 36 18 36C8.059 36 0 27.941 0 18C0 8.059 8.059 0 18 0C27.941 0 36 8.059 36 18Z" fill="#FFCC4D" />
          <path d="M18 21.849C15.034 21.849 13.065 21.503 10.631 21.03C10.074 20.924 8.99301 21.03 8.99301 22.668C8.99301 25.943 12.756 30.037 18 30.037C23.244 30.037 27.007 25.943 27.007 22.668C27.007 21.03 25.925 20.923 25.369 21.03C22.935 21.503 20.967 21.849 18 21.849Z" fill="#664500" />
          <path d="M16.65 3.28102C15.791 0.850024 13.126 -0.425976 10.694 0.431024C9.21802 0.951024 8.17301 2.14202 7.76601 3.53502C6.57501 2.70602 5.01501 2.43502 3.54101 2.95502C1.11101 3.81302 -0.166985 6.48002 0.692015 8.91102C0.814015 9.25502 0.976015 9.57402 1.16401 9.86902C3.11501 13.451 8.75202 15.969 12.165 16C14.802 13.833 17.611 8.33502 16.883 4.32302C16.845 3.97502 16.77 3.62502 16.65 3.28102ZM19.35 3.28102C20.209 0.850024 22.875 -0.425976 25.306 0.431024C26.782 0.951024 27.827 2.14202 28.235 3.53502C29.426 2.70602 30.986 2.43502 32.46 2.95502C34.89 3.81302 36.167 6.48002 35.31 8.91102C35.187 9.25502 35.026 9.57402 34.837 9.86902C32.886 13.451 27.249 15.969 23.835 16C21.198 13.833 18.39 8.33502 19.118 4.32302C19.155 3.97502 19.23 3.62502 19.35 3.28102Z" fill="#DD2E44" />
        </svg>
      </IconContainer>
      <TextArea
        ref={textareaRef}
        value={textValue}
        onChange={(event) => handleTextChange(event)}
        maxLength={MAX_LENGTH}
        placeholder="Tell us more about your experience"
      />
      <CharCount>
        {MAX_LENGTH - textValue.length} / {MAX_LENGTH}
        {' '}characters left
      </CharCount>
      <ButtonContainer>
        <Button className='submit' onClick={handleClick}>Submit Feedback</Button>
      </ButtonContainer>
    </FeedbackModalContainer>
  );
};

export default FeedbackModal;
